import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Index from "@/pages/Index";
import Guide from "@/pages/Guide";
import Tickets from "@/pages/Tickets";
import Lineup from "@/pages/Lineup";
import ArtistDetail from "@/pages/ArtistDetail";
import Travel from "@/pages/Travel";
import Parking from "@/pages/Parking";
import Schedule from "@/pages/Schedule";
import AdmiralsMenu from "@/pages/AdmiralsMenu";
import CaptainsWelcome from "@/pages/CaptainsWelcome";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import LifestyleV2 from "@/pages/LifestyleV2";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import Terms from "@/pages/Terms";
import Festival from "@/pages/Festival";
import TestCheckout from "@/pages/TestCheckout";
import Join from "@/pages/Join";
import MusicGivingHope from "@/pages/MusicGivingHope";
import MothersDay from "@/pages/MothersDay";
import PreParty from "@/pages/PreParty";
import TicketGiveaway from "@/pages/TicketGiveaway";
import Creators from "@/pages/Creators";
import CreatorRequest from "@/pages/CreatorRequest";
import ArtistUpload from "@/pages/ArtistUpload";
import { GoRedirect, RepostRedirect, RecapRedirect, TradeFirstRedirect } from "@/pages/CreatorRedirects";
import CrewRedirect from "@/pages/CrewRedirect";
import PageTransition from "./PageTransition";


// Strip trailing slashes from URLs (except homepage)
const TrailingSlashRedirect = () => {
  const location = useLocation();
  if (location.pathname !== "/" && location.pathname.endsWith("/")) {
    return <Navigate to={location.pathname.slice(0, -1) + location.search + location.hash} replace />;
  }
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  // Handle trailing slash redirect before rendering routes
  if (location.pathname !== "/" && location.pathname.endsWith("/")) {
    return <Navigate to={location.pathname.slice(0, -1) + location.search + location.hash} replace />;
  }

  return (
    <>
    
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* WordPress migration redirects - specific pages */}
        <Route path="/entertainment" element={<Navigate to="/lineup" replace />} />
        <Route path="/hotels" element={<Navigate to="/travel" replace />} />
        <Route path="/boatersbalcony" element={<Navigate to="/guide" replace />} />
        <Route path="/fleetwood-mac" element={<Navigate to="/lineup" replace />} />
        <Route path="/ticktes" element={<Navigate to="/tickets" replace />} />

        {/* WordPress migration redirects - junk pages to homepage */}
        <Route path="/home-new" element={<Navigate to="/" replace />} />
        <Route path="/joinwaitlist" element={<Navigate to="/" replace />} />
        <Route path="/viatext" element={<Navigate to="/" replace />} />
        <Route path="/viaemail" element={<Navigate to="/" replace />} />
        <Route path="/rock-activation" element={<Navigate to="/" replace />} />
        <Route path="/giveaway-m6q8r2d7" element={<Navigate to="/" replace />} />
        <Route path="/apply-m6q8r2d7" element={<Navigate to="/" replace />} />
        <Route path="/activate-m6q8r2d7" element={<Navigate to="/" replace />} />
        <Route path="/manage-profile" element={<Navigate to="/" replace />} />
        <Route path="/elementor-page-1468" element={<Navigate to="/" replace />} />
        <Route path="/elementor-page-2378" element={<Navigate to="/" replace />} />
        <Route path="/2025/03/13/hello-world" element={<Navigate to="/" replace />} />

        {/* Main page routes */}
        {/* DISABLED: PageTransition curtain animation */}
        <Route path="/" element={<Index />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/lineup" element={<Lineup />} />
        <Route path="/lineup/:slug" element={<ArtistDetail />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/parking" element={<Parking />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/set-times" element={<Navigate to="/schedule" replace />} />
        <Route path="/admirals-menu" element={<AdmiralsMenu />} />
        {/* Post-festival (2026-07-19): day-of pages retired — redirect, never 404 */}
        <Route path="/captains-welcome" element={<Navigate to="/" replace />} />
        <Route path="/captainswelcome" element={<Navigate to="/" replace />} />
        <Route path="/menu" element={<Navigate to="/admirals-menu" replace />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/lifestyle" element={<LifestyleV2 />} />
        <Route path="/lifestyle/blog" element={<Blog />} />
        <Route path="/lifestyle/blog/:slug" element={<BlogPost />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/festival" element={<Festival />} />
        <Route path="/test-checkout" element={<TestCheckout />} />
        <Route path="/join" element={<Join />} />
        <Route path="/music-giving-hope" element={<MusicGivingHope />} />
        {/* Past-event pages retired post-festival — redirect home */}
        <Route path="/mothers-day" element={<Navigate to="/" replace />} />
        <Route path="/preparty" element={<Navigate to="/" replace />} />
        <Route path="/ticket-giveaway" element={<Navigate to="/" replace />} />
        {/* Ghost page — not linked in nav */}
        <Route path="/creators" element={<Creators />} />
        <Route path="/creator-request" element={<CreatorRequest />} />
        <Route path="/artist-upload" element={<ArtistUpload />} />
        {/* Creator Crew branded short links (client-side redirect) */}
        <Route path="/go/:code" element={<GoRedirect />} />
        <Route path="/repost/:c" element={<RepostRedirect />} />
        <Route path="/recap" element={<RecapRedirect />} />
        <Route path="/recap-video" element={<RecapRedirect />} />
        <Route path="/tradefirst" element={<TradeFirstRedirect />} />
        <Route path="/pre-party" element={<Navigate to="/preparty" replace />} />
        <Route path="/high-tide" element={<Navigate to="/preparty" replace />} />
        
        {/* Crew Captain vanity links: /FirstnameLastname -> personal
            affiliate link (case-insensitive). Single-segment dynamic route,
            so every static route above wins; unknown names render the 404
            inside CrewRedirect. */}
        <Route path="/:slug" element={<CrewRedirect />} />

        {/* 404 catch-all */}
        {/* <Route path="*" element={<PageTransition><NotFound /></PageTransition>} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
    </>
  );
};

export default AnimatedRoutes;
